import * as React from "react";
import { Box, Typography } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { RequestButton } from "@tlc/ls2pac/components/place-hold/RequestButton";
import { LSResultItemShelfLocation } from "../ls/LSResultItem/LSResultItemShelfLocation";
import { LSResultItemLayout } from "../ls/LSResultItem/LSResultItemLayout";
import { LSResultItemBookjacket } from "../ls/LSResultItem/LSResultItemBookjacket";
import { LSResultItemTitle } from "../ls/LSResultItem/LSResultItemTitle";
import { LSResultItemAuthor } from "../ls/LSResultItem/LSResultItemAuthor";
import { LSResultItemAvailability } from "../ls/LSResultItem/LSResultItemAvailability";
import { AddToListButton } from "../../resource/AddToListButton";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";

interface LSReserveResultProps {
  result: ResourceView;
}

export const LSReservesResult = React.memo(
  function SearchResult({ result }: LSReserveResultProps) {
    const { translate } = useLanguage();

    const actionsComponent = (
      <>
        <RequestButton resource={result} />
        {/* TODO does the request button have a conditional that only works with reserves same with add to list */}
        <AddToListButton resourceId={result.id}></AddToListButton>
      </>
    );

    const reserveCourseStyle = {
      fontWeight: "bold",
      lineHeight: 1.4,
      m: 0,
      p: 0,
    };

    return (
      <LSResultItemLayout
        checkboxComponent={null}
        bookjacketComponent={<LSResultItemBookjacket resource={result} />}
        titleComponent={<LSResultItemTitle resource={result} />}
        actionsComponent={actionsComponent}
        authorComponent={
          <LSResultItemAuthor shortAuthor={result.shortAuthor} />
        }
        sx={{
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        {/* TODO Find a better key to map too maybe holdingsInformationID + itemID  */}
        {/* TODO test this block against an item with more than 12 possible courses */}
        {result.reserveInfos && result.reserveInfos.length > 0 && (
          <Box sx={{ mt: 1 }}>
            {result.reserveInfos.map((reserveInfo, index) => (
              <Box
                key={index}
                sx={{ mb: index < result.reserveInfos.length - 1 ? 2 : 0 }}
              >
                <Typography variant="body2" sx={reserveCourseStyle}>
                  {translate("department")}:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {reserveInfo.departmentComment}{" "}
                    {reserveInfo.department && <>{reserveInfo.department}</>}
                  </span>
                </Typography>

                <Typography variant="body2" sx={reserveCourseStyle}>
                  {translate("course")}:{" "}
                  {reserveInfo.course?.trim() && (
                    <span style={{ fontWeight: "normal" }}>
                      {reserveInfo.course}
                      {reserveInfo.courseComment?.trim() && (
                        <> - {reserveInfo.courseComment}</>
                      )}
                    </span>
                  )}
                </Typography>

                {reserveInfo.instructorName?.trim() && (
                  <Typography variant="body2" sx={reserveCourseStyle}>
                    {translate("instructor")}:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {reserveInfo.instructorName}
                    </span>
                  </Typography>
                )}
              </Box>
            ))}
          </Box>
        )}

        <LSResultItemAvailability resource={result} reserves={true} />
        <LSResultItemShelfLocation resource={result} isReserves={true} />
      </LSResultItemLayout>
    );
  },
  (prevProps, nextProps) => prevProps.result.id === nextProps.result.id
);
